// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-logo {
    height: 40vmin;
    pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
    .App-logo {
        animation: App-logo-spin infinite 20s linear;
    }
}

.App-header {
    background-color: #0f0f10;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: calc(10px + 2vmin);
    color: white;
}

.App-link {
    color: #61dafb;
}

@keyframes App-logo-spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(360deg);
    }
}

/* Bloqueo agresivo de cualquier elemento de Emergent */
[class*="emergent"], 
[id*="emergent"], 
.made-with-emergent,
div[style*="z-index: 9999"] { /* A veces usan z-index muy altos para flotar */
    display: none !important;
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;
}
/* Fondo oscuro translúcido para el modal de superadmin */
.modal-superadmin {
  background: rgba(15, 23, 42, 0.85) !important; /* Fondo slate oscuro */
  backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

/* Etiquetas e inputs legibles */
.modal-superadmin label {
  color: #e2e8f0 !important; /* Gris claro/blanco */
  font-weight: 600;
}

.modal-superadmin input,
.modal-superadmin textarea {
  background: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: #ffffff !important;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,uBAAuB;IAC3B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA,uDAAuD;AACvD;;;8BAG8B,+CAA+C;IACzE,wBAAwB;IACxB,qBAAqB;IACrB,6BAA6B;IAC7B,+BAA+B;AACnC;AACA,yDAAyD;AACzD;EACE,6CAA6C,EAAE,uBAAuB;EACtE,2BAA2B;EAC3B,0CAA0C;EAC1C,cAAc;AAChB;;AAEA,gCAAgC;AAChC;EACE,yBAAyB,EAAE,sBAAsB;EACjD,gBAAgB;AAClB;;AAEA;;EAEE,gDAAgD;EAChD,qDAAqD;EACrD,yBAAyB;AAC3B","sourcesContent":[".App-logo {\n    height: 40vmin;\n    pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n    .App-logo {\n        animation: App-logo-spin infinite 20s linear;\n    }\n}\n\n.App-header {\n    background-color: #0f0f10;\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    font-size: calc(10px + 2vmin);\n    color: white;\n}\n\n.App-link {\n    color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n    from {\n        transform: rotate(0deg);\n    }\n    to {\n        transform: rotate(360deg);\n    }\n}\n\n/* Bloqueo agresivo de cualquier elemento de Emergent */\n[class*=\"emergent\"], \n[id*=\"emergent\"], \n.made-with-emergent,\ndiv[style*=\"z-index: 9999\"] { /* A veces usan z-index muy altos para flotar */\n    display: none !important;\n    opacity: 0 !important;\n    visibility: hidden !important;\n    pointer-events: none !important;\n}\n/* Fondo oscuro translúcido para el modal de superadmin */\n.modal-superadmin {\n  background: rgba(15, 23, 42, 0.85) !important; /* Fondo slate oscuro */\n  backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n/* Etiquetas e inputs legibles */\n.modal-superadmin label {\n  color: #e2e8f0 !important; /* Gris claro/blanco */\n  font-weight: 600;\n}\n\n.modal-superadmin input,\n.modal-superadmin textarea {\n  background: rgba(255, 255, 255, 0.05) !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  color: #ffffff !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
